<template>
  <div class="payroll-emp-info-employee-info">
    <div class="payroll-emp-info-panel">
      <div class="payroll-emp-info-panel-header">
        <span class="icon">👤</span>
        <h2>Employee Information</h2>
      </div>
      <div class="payroll-emp-info-panel-body">
        <div class="payroll-emp-info-form-group">
          <label>Name</label>
          <input type="text" v-model="localEmployee.employeeName" disabled class="payroll-disabled-field" />
        </div>
        <div class="payroll-emp-info-form-group">
          <div class="input-with-reset">
            <label>Basic Salary (PKR)</label>
            <ResetIconButton @reset="() => resetEmptyField('basicSalary')" />
          </div>
          <input type="number" v-model="localEmployee.basicSalary" @input="handleChange" :disabled="isDisabled"
            placeholder="0" @wheel="$event.target.blur()" :class="{ 'updated-field': hasChanged('basicSalary') }" />
        </div>
        <div class="payroll-emp-info-form-group">
          <div class="input-with-reset">
            <label for="extraAllowanceInput">Extra Allowance (PKR)</label>
            <ResetIconButton @reset="() => resetEmptyField('extraAllowance')" />
          </div>

          <input type="number" v-model="localEmployee.extraAllowance" @input="handleChange" placeholder="0"
            :disabled="isDisabled" @wheel="$event.target.blur()" :class="{ 'updated-field': hasChanged('extraAllowance') }" />
        </div>
        <div class="payroll-emp-info-form-group">
          <label>Per Day Salary (PKR)</label>
          <input type="number" v-model="localEmployee.perDaySalary" @input="manualOverride" :disabled="isDisabled"
            disabled class="payroll-disabled-field" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResetIconButton from "../../../UIComponents/Buttons/ResetIconButton.vue";

export default {
  name: "EmployeeInfo",
  components: {
    ResetIconButton
  },
  props: ["employee", "initialValues"],
  data() {
    return {
      localEmployee: {
        employeeName: "",
        basicSalary: 0,
        extraAllowance: 0,
        perDaySalary: 0,
        requiredWorkingDays: 0,
      },
      perDaySalaryManuallySet: false,
      originalEmployee: {},
    };
  },
  computed: {
    isDisabled() {
      return this.$store.state.auth.user.role !== "admin";
    },
  },
  watch: {
    employee: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.localEmployee = {
          employeeName: newVal.employeeName || "",
          basicSalary: newVal.basicSalary || "",
          extraAllowance: newVal.extraAllowance || "",
          perDaySalary: newVal.perDaySalary || 0,
          requiredWorkingDays: newVal.requiredWorkingDays || 0,
        };
        this.perDaySalaryManuallySet = false;
        this.autoCalculatePerDaySalary();
        this.originalEmployee = Object.assign({}, this.localEmployee);
      },
    },
  },
  methods: {
    handleChange() {
      if (!this.perDaySalaryManuallySet) {
        this.autoCalculatePerDaySalary();
      }
      this.$emit("update-employee", this.localEmployee);
    },
    manualOverride() {
      this.perDaySalaryManuallySet = true;
      this.$emit("update-employee", this.localEmployee);
    },
    autoCalculatePerDaySalary() {
      const basic = parseFloat(this.localEmployee.basicSalary) || 0;
      const extra = parseFloat(this.localEmployee.extraAllowance) || 0;
      const days = parseInt(this.localEmployee.requiredWorkingDays, 10) || 0;

      if (days > 0) {
        this.localEmployee.perDaySalary = parseFloat(((basic + extra) / days).toFixed(2));
      }
    },
    resetEmptyField(field) {
      const newValue = this.initialValues[field];

      if (
        this.localEmployee[field] === null ||
        this.localEmployee[field] === '' ||
        isNaN(this.localEmployee[field]) ||
        this.localEmployee[field] === 0 ||
        this.localEmployee[field] !== newValue
      ) {
        // Force Vue to detect the change
        this.$set(this.localEmployee, field, newValue);
        this.handleChange();
      }
    },
    hasChanged(field) {
      const value = this.localEmployee[field] !== this.initialValues[field]
      return value;
    }
  },

};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/PayrollManagement/PayrollDetails/EmployeeInformation/index.vue